import formatDecimal from './format-decimal';

var formatRounded = function formatRounded(a, b) {
  var c = formatDecimal(a, b);
  var d, e;
  return c ? (d = c[0], e = c[1], 0 > +e ? '0.' + Array(-e).join('0') + d : d.length > e + 1 ? d.slice(0, e + 1) + '.' + d.slice(e + 1) : d + Array(e - d.length + 2).join('0')) : a + '';
};

export default formatRounded;